import type { MessagePart, SuggestionSegment } from "./chat.types";

const SUGGESTION_SEGMENT_PATTERN =
  /```[^\S\r\n]*(?:[^\r\n`]*)\r?\n([\s\S]*?)```|<suggestion\b[^>]*>([\s\S]*?)<\/suggestion>/gi;

const normalizeSuggestionText = (text: string) => text.replace(/^\r?\n/, "").replace(/\r?\n$/, "");

export const extractDefaultSuggestionSegments = (messagePart: MessagePart): SuggestionSegment[] => {
  if (messagePart.type !== "text" || !messagePart.text) {
    return [];
  }

  return [...messagePart.text.matchAll(SUGGESTION_SEGMENT_PATTERN)]
    .map((match) => ({ text: normalizeSuggestionText(match[1] ?? match[2] ?? "") }))
    .filter((segment) => Boolean(segment.text.trim()));
};
